module.exports = __webpack_public_path__ + "img/crema, pomada, gel, pasta o unguento dermico.df19fa72.png";